import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { LandTransporter } from '../../types';

interface DroppableZoneProps {
  id: string;
  landTransporter?: LandTransporter | null;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  isunassigned?: boolean;
  'data-testid'?: string;
}

export const DroppableZone: React.FC<DroppableZoneProps> = ({
  id,
  landTransporter,
  children,
  className = '',
  style,
  isunassigned = false,
  'data-testid': dataTestId,
}) => {
  const { setNodeRef } = useDroppable({
    id,
    data: {
      type: isunassigned ? 'unassigned' : 'transporter',
      landTransporter,
    },
  });

  return (
    <div
      ref={setNodeRef}
      className={`relative ${className}`}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
